const AuthenticationStore = {
	isAuthenticationRequired:!(window.env.OAM_AUTHENTICATION===true||window.env.OAM_AUTHENTICATION==='true'),
	initialized : false,
	tokenId:"",
	refreshToken:"",
	loadFromLocal(){
		//this.refreshToken = this.cookies.get('refreshToken');
	},
	isAuthenticated () {
		return this.isAuthenticationRequired?(this.initialized?this.tokenId !== "" && this.tokenId !== undefined:false):true;
	},
	getTokenId () {
		return this.tokenId;
	},
	setTokenId (newTokenId,newRefreshToken) {
		this.tokenId=newTokenId;
		if(typeof newRefreshToken !=='undefined'){
			this.refreshToken = newRefreshToken;
			this.initialized = true;
		}
	},
	cleanup(){
		this.initialized = false;
	}
};

export default AuthenticationStore;